import { SankeyDataNode } from "../../../Charts/SankeyDiagram/SankeyDiagram.type";

export const nodesData: SankeyDataNode[] = [
	{
		label: "EU27",
		nodeColor: "#0047ba",
	},
	{
		label: "Rest of Europe",
		nodeColor: "#3cb4e5",
	},
	{
		label: "Asia",
		nodeColor: "#3cb4e5",
	},
	{
		label: "Americas",
		nodeColor: "#3cb4e5",
	},
	{
		label: "Africa",
		nodeColor: "#3cb4e5",
	},
	{
		label: "Oceania",
		nodeColor: "#3cb4e5",
	},
	{
		label: "Total",
		nodeColor: "#0047ba",
	},
];

export const linkConnectionColors = { euColor: "#6691d6", restOfEuColor: "#8ad2ef", defaultColor: "#8ad2ef" };
export const unitValue: { euro: "valueInEuros"; kg: "quantityInKg" } = { euro: "valueInEuros", kg: "quantityInKg" };
